import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootPrintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_update_serial_numbersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { serial_numbers: $frontendTypes.FootPrintApiManager.input_update_serial_number[] }): Promise<{ serial_numbers: $frontendTypes.FootPrintApiManager.public_serial_number[], errors: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serial_numbers)) {
      missingRequiredInParams.push('\'serial_numbers\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

